import { hasSectionGoal } from 'components/page/ForeignProfile/function/hasSectionGoal'
import { GQLForeignProfileFragment } from 'components/page/ForeignProfile/gql/__generated__/ForeignFragments'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { GQLGender } from 'generated-graphql/graphql'

import { iconsGoals } from '../../Profile.constants'
import { ProfileListType } from '../../Profile.types'

export const findDatingGoals = (
  profile: GQLForeignProfileFragment,
  ui: GQLForeignRootQuery['ui'],
  lgbtRestriction?: boolean
) => {
  if (
    !hasSectionGoal(profile.dating.lookFor, profile.gender, lgbtRestriction)
  ) {
    return []
  }

  return profile.dating.datingGoals?.map((datingGoal) => {
    const _lexeme = ui.glossary.datingProfile.datingGoals.find(
      ({ value }) => value === datingGoal
    )

    const _genderLexeme =
      profile.gender === GQLGender.M
        ? _lexeme?.maleLexeme
        : _lexeme?.femaleLexeme

    return {
      icon: iconsGoals[datingGoal],
      title: _genderLexeme,
      ['data-name']: _lexeme?.value,
    }
  }) as ProfileListType[]
}
